import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import StockNavbar from "./StockNavbar";

const AddStockRegisterType = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  document.title = "Add Stock Register Type";

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Stock/AddStockRegisterType",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        RegisterName: event.target.RegisterName.value,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/StockManagement/ManageStockRegisterTypes");
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });

    setValidated(true);
  };

  return (
    <>
      <StockNavbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/StockManagement/StocksDashboard">Stocks</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add Register Type
                  </li>
                </ol>
              </nav>
              <div className="page-title">Add Stock Register Type</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/StockManagement/ManageStockRegisterTypes"
                  className="button button-white button-icon"
                >
                  Manage Register Types
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body p-md-4">
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row align-items-end gy-3">
                  <div className="col-md-6">
                    <label>Register Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="RegisterName"
                      required
                      maxLength={300}
                    />
                  </div>
                  <div className="col-md-2 text-end">
                    {loading ? (
                      <Spinner animation="border" role="status" />
                    ) : (
                      <button type="submit" className="button button-primary w-100">
                        SAVE
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddStockRegisterType;
